const C = require("../constants");
const initial_data = {open: false, category:{id:null, name:'', image:null}};

function CategoryDialogReducer(state = initial_data, action) {
    switch (action.type) {
        case C.CATEGORY_DIALOG:
            return action.data;
        default:
            return state;
    }
}

export default CategoryDialogReducer;


// WEBPACK FOOTER //
// ./src/reducers/CategoryDialogReducer.js